module.exports = __webpack_public_path__ + "static/media/6_Roller_Coaster.417f9788.png";